import { render } from "./A107040.vue?vue&type=template&id=6130b9de&scoped=true"
import script from "./A107040.vue?vue&type=script&lang=js"
export * from "./A107040.vue?vue&type=script&lang=js"

import "./A107040.vue?vue&type=style&index=0&id=6130b9de&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6130b9de"]])

export default __exports__